import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { EducationalAdvisorPendingActionsVM } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";

export const educationalAdvisorRetrievePendingActions = createAsyncThunk<
  EducationalAdvisorPendingActionsVM,
  void,
  { extra: Partial<Dependencies> }
>("educationalAdvisor/educationalAdvisorRetrievePendingActions", async (_: void, { extra: { educationalAdvisorRepository } }) => {
  return educationalAdvisorRepository!.hasPendingActions();
});
